import { Pipe, PipeTransform, inject } from '@angular/core';
import { DateValue, isNil, Nillable } from '@web/utils';
import { DateFormatService } from '../services/date-format.service';
import { DD_MM_YYYY } from '@web/common';

@Pipe({
  name: 'dateFormat',
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {
  private readonly dateFormat = inject(DateFormatService);

  public transform(
    value: Nillable<DateValue>,
    format = DD_MM_YYYY,
  ): Nillable<string> {
    if (isNil(value)) {
      return value;
    }

    return this.dateFormat.format(value, format);
  }
}
